

export class CloseParent {


    static functionByFullName(path : string) {
        const pathElements: string[] = path.split('.')
        /*🤫*/
        /*🤫*/
        return [window].concat(pathElements).reduce( (prev, curr) => {
            /*🤫*/
            /*🤫*/
            return prev[curr];
        });
    }

    static initClickListeners():void {
        const targetClass = "or_js_closeParent";
        window.o_util.event.delegate(document, "click", "." + targetClass, function (event) {
            const target = event.target as (Element | null);
            if (target) {
                const btn = target.classList.contains(targetClass) ? target : window.o_util.dom.getParentByClassName(target, targetClass);

                /*🤫*/
                if (!!btn) {
                    const parent = btn.parentElement;
                    const fnName = btn.getAttribute("data-callback");
                    const callback = !!fnName ? CloseParent.functionByFullName(fnName) : undefined;
                    if (!!parent) {
                        parent.style.display = "none";
                    }
                    if (callback !== undefined && typeof callback === "function") {
                        /*🤫*/
                        /*🤫*/
                        callback();
                    }
                }
            }
        });
    }

    static initialize(): void {
        const o_order = window.o_order ?? {};
        o_order.common = o_order.common ?? {};

        o_order.common.initCloseParentsHandler = CloseParent.initClickListeners;

        if (!window.o_order.common.initialized) {
            window.o_global.eventLoader.onReady(50, function () {
                CloseParent.initClickListeners();
            });
            window.o_order.common.initialized = true;
        }
    }
}
